import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsDeleteAdminBuildings_buildingIdEnpiSnapshots_snapshotId = z.any()
export type TagsDeleteAdminBuildings_buildingIdEnpiSnapshots_snapshotId = z.infer<typeof tagsDeleteAdminBuildings_buildingIdEnpiSnapshots_snapshotId>

export const paramsDeleteAdminBuildings_buildingIdEnpiSnapshots_snapshotId = z.object({ "buildingId": z.string().uuid(), "snapshotId": z.string().uuid() })
export type ParamsDeleteAdminBuildings_buildingIdEnpiSnapshots_snapshotId = z.infer<typeof paramsDeleteAdminBuildings_buildingIdEnpiSnapshots_snapshotId>

export const responseDeleteAdminBuildings_buildingIdEnpiSnapshots_snapshotId = z.object({ "payload": z.object({ "deleted": z.boolean() }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseDeleteAdminBuildings_buildingIdEnpiSnapshots_snapshotId = z.infer<typeof responseDeleteAdminBuildings_buildingIdEnpiSnapshots_snapshotId>

interface IDeleteAdminBuildings_buildingIdEnpiSnapshots_snapshotId extends BaseMethodType {
  tags: TagsDeleteAdminBuildings_buildingIdEnpiSnapshots_snapshotId,
  params: ParamsDeleteAdminBuildings_buildingIdEnpiSnapshots_snapshotId,
  response: ResponseDeleteAdminBuildings_buildingIdEnpiSnapshots_snapshotId
}
export const URL = '/admin/buildings/:buildingId/enpi/snapshots/:snapshotId'
export const validation = {
  delete: {
    tags: tagsDeleteAdminBuildings_buildingIdEnpiSnapshots_snapshotId,
    params: paramsDeleteAdminBuildings_buildingIdEnpiSnapshots_snapshotId,
    response: responseDeleteAdminBuildings_buildingIdEnpiSnapshots_snapshotId
  }
}
export interface AdminBuildings_buildingIdEnpiSnapshots_snapshotId extends BaseRouteType {
  delete: IDeleteAdminBuildings_buildingIdEnpiSnapshots_snapshotId
}